
import Vue from "vue";

import { quoteMapState } from "@/store/modules/quote";
import {
  watercraftTypeMapActions,
  watercraftTypeMapGetters
} from "@/store/modules/watercraftType";
import { getLabelFromOptions } from "@/helpers/getLabelFromOptions";
import * as selectOptions from "@/helpers/selectOptions";

export default Vue.extend({
  inheritAttrs: false,
  name: "DisplayHO215Data",
  mounted() {
    this.getWatercraftTypes({ query: { __limit: 500 } }).catch((error: any) => {
      this.$bugSnagClient.notify(error);
    });
  },
  methods: {
    ...watercraftTypeMapActions(["getWatercraftTypes"]),
    getWaterCraftLabel(value: string): string {
      return getLabelFromOptions(value, this.waterCraftTypesList);
    }
  },
  computed: {
    ...quoteMapState(["editing"]),
    ...watercraftTypeMapGetters(["watercraftTypes"]),
    waterCraftTypesList(): { value: string; label: string }[] {
      if (!this.watercraftTypes || !this.watercraftTypes.length) {
        return selectOptions.waterCraftTypes;
      }
      return this.watercraftTypes
        .filter((watercraftType: any) => !watercraftType.deleted)
        .map((watercraftType: any) => ({
          value: watercraftType.value,
          label: watercraftType.label
        }));
    },
    editingEndorsement(): any {
      if (this.editing && this.editing.endorsements) {
        return this.editing.endorsements.find(
          (endorsement: any) => endorsement.formCode === "215"
        );
      }
      return [];
    },
    numberOfWaterCrafts(): any {
      if (
        this.editingEndorsement &&
        this.editingEndorsement.values &&
        this.editingEndorsement.values.length > 0
      ) {
        const match = this.editingEndorsement.values.find(
          (value: any) => value.key == "m_fmNumWaterCraft"
        );
        return match ? match.value : "";
      }
      return {};
    },
    waterCraftData(): any {
      if (
        this.editingEndorsement &&
        this.editingEndorsement.values &&
        this.editingEndorsement.values.length > 0
      ) {
        const match = this.editingEndorsement.values.find(
          (value: any) => value.key == "waterCraftData"
        );
        return match ? match.value : {};
      }
      return {};
    }
  }
});
